;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import type { JwtOrganisation, JwtPayload, JwtUser } from '@workspace/ui/types';

interface ActiveOrganisationSource {
  active_organisation?: JwtOrganisation;
  organisations?: JwtOrganisation[];
}

export function getActiveOrganisationFromToken(
  decodedToken: JwtPayload | null | undefined
): JwtOrganisation | undefined {
  return decodedToken?.active_organisation ?? decodedToken?.organisations?.[0];
}

export function getActiveOrganisationFromUser(
  user: ActiveOrganisationSource | null | undefined
): JwtOrganisation | undefined {
  return user?.active_organisation ?? user?.organisations?.[0];
}

export function getOrganisationsFromUser(
  user: ActiveOrganisationSource | null | undefined
): JwtOrganisation[] {
  const organisations = user?.organisations ?? [];
  const activeOrganisation = getActiveOrganisationFromUser(user);
  if (!activeOrganisation) return organisations;
  if (organisations.some((organisation) => organisation.id === activeOrganisation.id)) {
    return organisations;
  }
  return [activeOrganisation, ...organisations];
}

export function createJwtUserFromPayload(decodedToken: JwtPayload): JwtUser {
  return {
    user: {
      id: Number(decodedToken.sub),
      first_name: decodedToken.user.first_name,
      last_name: decodedToken.user.last_name,
      email: decodedToken.user.email,
    },
    permissions: decodedToken.permissions,
    roles: decodedToken.roles,
    organisations: decodedToken.organisations ?? [],
    active_organisation: getActiveOrganisationFromToken(decodedToken),
    accessible_app: decodedToken.accessible_app,
    teams: decodedToken.teams,
    has_completed_nps: decodedToken.has_completed_nps,
  };
}
